
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Control } from "react-hook-form";
import { cn } from "@/lib/utils";
import { ReadingFormValues } from "./types";

type ReadingDateFieldProps = {
  control: Control<ReadingFormValues>;
};

export const ReadingDateField = ({ control }: ReadingDateFieldProps) => {
  return (
    <FormField
      control={control}
      name="reading_date"
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabel>Fecha</FormLabel>
          <Popover>
            <PopoverTrigger asChild>
              <FormControl>
                <Button
                  variant={"outline"}
                  className={cn(
                    "w-full pl-3 text-left font-normal",
                    !field.value && "text-muted-foreground"
                  )}
                >
                  {field.value ? (
                    format(field.value, "d 'de' MMMM 'de' yyyy", { locale: es })
                  ) : (
                    <span>Seleccione una fecha</span>
                  )}
                  <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                </Button>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 bg-white" align="start">
              <Calendar
                mode="single"
                selected={field.value}
                onSelect={field.onChange}
                initialFocus
                locale={es}
                className={cn("p-3 pointer-events-auto bg-white")}
              />
            </PopoverContent>
          </Popover>
        </FormItem>
      )}
    />
  );
};
